package com.partejar.app.feature.planos.data.remote

import kotlinx.serialization.Serializable

@Serializable
data class PlanoDto(
    val planoId: Long,
    val nome: String,
    val valorAtual: Double,
    val ativo: Boolean,
    val servicos: List<PlanoServicoDto> = emptyList()
)

@Serializable
data class PlanoServicoDto(val descricao: String, val ordemExibicao: Int)

@Serializable
data class PlanoServicoRequestDto(val descricao: String)

@Serializable
data class CriarPlanoDto(
    val nome: String,
    val valorAtual: Double,
    val servicos: List<PlanoServicoRequestDto>
)

@Serializable
data class AtualizarPlanoDto(
    val nome: String,
    val valorAtual: Double,
    val servicos: List<PlanoServicoRequestDto>,
    val ativo: Boolean
)
